// import { Config } from "sst/node/config"
import { z } from "zod"

import { DEFAULT_BASE_API_URL, DEFAULT_NODE_ENV } from "@/config/defaults"
import { makeID } from "@/lib/stringUtils"
import { Environment, TEnvironmentConfig } from "@/schemas/config"

export const environment: TEnvironmentConfig = {
  environment: z.string().trim().toLowerCase().catch(DEFAULT_NODE_ENV).parse("development") === "production" ? Environment.enum.Production : Environment.enum.Development,
  api: {
    baseURL: z.string().trim().url().catch(DEFAULT_BASE_API_URL).parse(process.env.NEXT_PUBLIC_API_BASE_URL),
    remoteURL: z.string().trim().url().catch("").parse(process.env.NEXT_PUBLIC_REMOTE_BASE_URL),
    launcherURL: z.string().trim().url().catch("").parse(process.env.NEXT_PUBLIC_LAUNCHER_BASE_URL),
  },
  dev: {
    jSessionIDCookie: z.string().trim().length(32).catch(makeID(32)).parse(process.env.JSESSIONID),
    launcherIDCookie: z.string().catch("").parse(process.env.LAUNCHERID),
  },
}
